import {Component, EventEmitter, Input, Output, OnInit, ViewChild, ElementRef} from '@angular/core';
import {BsDatepickerConfig} from 'ngx-bootstrap';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss'],
  host: {
    '(document:mousedown)': 'onClick($event)'
  }
})
export class UserComponent implements OnInit {

  @Input() user: any;

  @Input() users: any[];

  @Output() toggleActive = new EventEmitter();

  @Output() changePassword = new EventEmitter();

  @Output() changeChildren = new EventEmitter();

  @Output() changePlan = new EventEmitter();

  @Output() delete = new EventEmitter();

  @ViewChild('passwordPopover') passwordPopover;

  @ViewChild('childrenPopover') childrenPopover;

  userOptions: any;

  password: string;

  showPasswordPopup: boolean;

  showChildrenPopup: boolean;

  intermediateChildren: any[];

  bsConfig: Partial<BsDatepickerConfig>;

  plans = ['trial', 'slim', 'medium', 'large'];

  startDate;

  expDate;

  constructor() {}

  ngOnInit() {
    this.userOptions = this.users.filter(u => u._id !== this.user._id);
    this.intermediateChildren = this.user.children.map(c => c._id);

    this.bsConfig = Object.assign({}, { containerClass: 'theme-blue' });

    this.startDate = new Date(this.user.planStart);

    this.expDate = new Date(this.user.planExpiration);
  }

  private onClick(event): void {
    if (this.showPasswordPopup
      && (
        !this.passwordPopover._popover
        || !this.passwordPopover._popover._componentRef
        || !this.passwordPopover._popover._componentRef.location
        || !this.passwordPopover._popover._componentRef.location.nativeElement
        || !this.passwordPopover._popover._componentRef.location.nativeElement.contains(event.target)
      )
    ) {
      this.hidePasswordPopup();
    }

    if (this.showChildrenPopup
      && (
        !this.childrenPopover._popover
        || !this.childrenPopover._popover._componentRef
        || !this.childrenPopover._popover._componentRef.location
        || !this.childrenPopover._popover._componentRef.location.nativeElement
        || !this.childrenPopover._popover._componentRef.location.nativeElement.contains(event.target)
      )
    ) {
      this.hideChildrenPopup();
    }
  }

  hideChildrenPopup() {
    this.showChildrenPopup = false;
    this.childrenPopover.hide();
  }

  hidePasswordPopup() {
    this.showPasswordPopup = false;
    this.passwordPopover.hide();
  }

  doToggleActive(user) {
    this.toggleActive.next(user);
  }

  doChangePassword(user) {
    this.changePassword.next({user, password: this.password});
    this.password = '';
    this.showPasswordPopup = false;
  }

  save() {
    this.changeChildren.next(this.intermediateChildren);
    this.showChildrenPopup = false;
  }

  onChildChange(e, user) {
    if (e.target.checked) {
      this.intermediateChildren = [...this.intermediateChildren, user._id];
    } else {
      this.intermediateChildren = this.intermediateChildren.filter(ic => ic !== user._id);
    }
  }

  isChildChecked(user) {
    return this.intermediateChildren.indexOf(user._id) > -1;
  }

  deleteUser() {
    this.delete.next(this.user);
  }

  editPlan(e) {
    const newPlan = e.target.value;
    this.changePlan.next({plan: newPlan});
  }

  editStartDate(e) {
    if (this.startDate != e) {
      this.changePlan.next({planStart: e});
    }
  }

  editEndDate(e) {
    if (this.expDate != e) {
      this.changePlan.next({planExpiration: e});
    }
  }



}



// WEBPACK FOOTER //
// ./client/app/components/settings/users/user/user.component.ts